(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-strip"] && !Shopify.designMode) return;
  try {
    
  class BrandStripCarousel extends HTMLElement {
    constructor() {
      super();
      this.viewport = this.querySelector('[data-brand-strip-viewport]');
      this.prevButton = this.querySelector('[data-brand-strip-prev]');
      this.nextButton = this.querySelector('[data-brand-strip-next]');
    }

    connectedCallback() {
      if (!this.viewport) return;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      }

      this.onScroll = this.debounce(() => this.update(), 100);
      this.viewport.addEventListener('scroll', this.onScroll);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.onScroll);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.viewport && this.onScroll) {
        this.viewport.removeEventListener('scroll', this.onScroll);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    scrollByPage(direction) {
      this.viewport.scrollBy({ left: this.viewport.clientWidth * direction, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const hasOverflow = maxScroll > 1;
      const scrollLeft = this.viewport.scrollLeft;

      if (this.prevButton) {
        this.prevButton.hidden = !hasOverflow;
        this.prevButton.disabled = scrollLeft <= 1;
      }
      if (this.nextButton) {
        this.nextButton.hidden = !hasOverflow;
        this.nextButton.disabled = scrollLeft >= maxScroll - 1;
      }
    }

    debounce(fn, wait) {
      let timer;
      return () => {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }
  }

  if (!customElements.get('brand-strip-carousel')) {
    customElements.define('brand-strip-carousel', BrandStripCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saf-feature-strip"] && !Shopify.designMode) return;
  try {
    
  class SafFeatureStrip extends HTMLElement {
    connectedCallback() {
      this.mql = window.matchMedia('(min-width: 750px)');
      this.track = this.querySelector('.saf-feature-strip__track');
      this.onChange = () => this.sync();
      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.onChange);
      } else if (this.mql.addListener) {
        this.mql.addListener(this.onChange);
      }
      this.sync();
    }

    disconnectedCallback() {
      if (!this.mql) return;
      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onChange);
      } else if (this.mql.removeListener) {
        this.mql.removeListener(this.onChange);
      }
    }

    // Only animate on mobile when the content actually overflows the viewport.
    sync() {
      if (!this.track || this.dataset.autoscroll !== 'true') return;
      const isDesktop = this.mql.matches;
      const overflows = this.track.scrollWidth > this.clientWidth;
      this.track.style.animationPlayState = !isDesktop && overflows ? 'running' : 'paused';
    }
  }

  if (!customElements.get('saf-feature-strip')) {
    customElements.define('saf-feature-strip', SafFeatureStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saf-featured-collections"] && !Shopify.designMode) return;
  try {
    
  class SafFcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-saf-fc-track]');
      if (!this.track) return;

      this.items = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-saf-fc-dot]'));
      this.autorotate = this.dataset.autorotate === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.index = 0;
      this.timer = null;

      this.mqMobile = window.matchMedia('(max-width: 989px)');
      this.mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onScroll = this.debounce(() => this.syncFromScroll(), 80);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.safFcDot, 10));
          this.restart();
        });
      });

      this.pause = () => this.stop();
      this.resume = () => this.maybeStart();
      ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((evt) =>
        this.addEventListener(evt, this.pause, { passive: true })
      );
      ['mouseleave', 'focusout', 'touchend', 'pointerup'].forEach((evt) =>
        this.addEventListener(evt, this.resume, { passive: true })
      );

      this.onMqChange = () => this.maybeStart();
      this.mqMobile.addEventListener('change', this.onMqChange);
      this.mqReduced.addEventListener('change', this.onMqChange);

      this.onVisibility = () => (document.hidden ? this.stop() : this.maybeStart());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.maybeStart();
    }

    disconnectedCallback() {
      this.stop();
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.mqMobile) this.mqMobile.removeEventListener('change', this.onMqChange);
      if (this.mqReduced) this.mqReduced.removeEventListener('change', this.onMqChange);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    shouldRotate() {
      return (
        this.autorotate &&
        this.items.length > 1 &&
        this.mqMobile.matches &&
        !this.mqReduced.matches
      );
    }

    maybeStart() {
      this.stop();
      if (this.shouldRotate()) {
        this.timer = window.setInterval(() => this.next(), this.interval);
      }
    }

    restart() {
      this.maybeStart();
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.goTo((this.index + 1) % this.items.length);
    }

    goTo(index) {
      const item = this.items[index];
      if (!item) return;
      this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.setActive(index);
    }

    syncFromScroll() {
      const scrollLeft = this.track.scrollLeft;
      let closest = 0;
      let min = Infinity;
      this.items.forEach((item, i) => {
        const distance = Math.abs(item.offsetLeft - this.track.offsetLeft - scrollLeft);
        if (distance < min) {
          min = distance;
          closest = i;
        }
      });
      this.setActive(closest);
    }

    setActive(index) {
      this.index = index;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        window.clearTimeout(t);
        t = window.setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('saf-fc-carousel')) {
    customElements.define('saf-fc-carousel', SafFcCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
